module.exports = __webpack_public_path__ + "41c03f504109312693b997e90c9bb591.png";